import { rememberOpenFilterMenu } from "packs/backoffice-participants-filter-menu-persist"
import { refreshParticipantsLive } from "packs/backoffice-participants-live-refresh"

const syncCatalogueFields = (root, form) => {
  const completeInput = root.querySelector("[data-participants-catalogue-complete-input]")
  const incompleteInput = root.querySelector("[data-participants-catalogue-incomplete-input]")
  const completeField = form.querySelector("[data-participants-catalogue-complete]")
  const incompleteField = form.querySelector("[data-participants-catalogue-incomplete]")
  if (!completeInput || !incompleteInput || !completeField || !incompleteField) return

  completeField.value = completeInput.checked ? "1" : "0"
  incompleteField.value = incompleteInput.checked ? "1" : "0"
}

const applyCatalogueFilter = async (root, form) => {
  syncCatalogueFields(root, form)
  rememberOpenFilterMenu("catalogue", "catalogue")
  const ok = await refreshParticipantsLive(form)
  if (ok) sessionStorage.removeItem("backoffice-participants-filter-menu-open")
}

const closeCatalogueMenu = (root) => {
  const trigger = root.querySelector("[data-participants-catalogue-filter-trigger]")
  const menu = root.querySelector("[data-participants-catalogue-filter-menu]")
  const pill = root.querySelector(".backoffice-participants-catalogue-filter__pill")
  if (!trigger || !menu) return

  menu.hidden = true
  trigger.setAttribute("aria-expanded", "false")
  trigger.classList.remove("is-open")
  if (pill) pill.classList.remove("is-open")
}

const openCatalogueMenu = (root) => {
  const trigger = root.querySelector("[data-participants-catalogue-filter-trigger]")
  const menu = root.querySelector("[data-participants-catalogue-filter-menu]")
  const pill = root.querySelector(".backoffice-participants-catalogue-filter__pill")
  if (!trigger || !menu) return

  menu.hidden = false
  trigger.setAttribute("aria-expanded", "true")
  trigger.classList.add("is-open")
  if (pill) pill.classList.add("is-open")
}

const bindCatalogueFilter = (root) => {
  if (root.dataset.bound === "true") return
  root.dataset.bound = "true"

  const trigger = root.querySelector("[data-participants-catalogue-filter-trigger]")
  const menu = root.querySelector("[data-participants-catalogue-filter-menu]")
  const form =
    document.querySelector("form[data-participants-catalogue-filter-form]") ||
    document.querySelector("form[data-auto-search]")
  if (!trigger || !menu || !form) return

  trigger.addEventListener("click", (event) => {
    event.preventDefault()
    event.stopPropagation()
    document.querySelectorAll("[data-participants-status-filter]").forEach((node) => {
      const otherTrigger = node.querySelector("[data-participants-status-filter-trigger]")
      const otherMenu = node.querySelector("[data-participants-status-filter-menu]")
      const otherPill = node.querySelector(".backoffice-participants-inscription-filter__pill")
      if (!otherTrigger || !otherMenu) return
      otherMenu.hidden = true
      otherTrigger.setAttribute("aria-expanded", "false")
      otherTrigger.classList.remove("is-open")
      if (otherPill) otherPill.classList.remove("is-open")
    })
    if (menu.hidden) {
      openCatalogueMenu(root)
    } else {
      closeCatalogueMenu(root)
    }
  })

  menu.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      applyCatalogueFilter(root, form)
    })
  })

  menu.addEventListener("click", (event) => {
    event.stopPropagation()
  })
}

const initBackofficeParticipantsCatalogueFilter = () => {
  document.querySelectorAll("[data-participants-catalogue-filter]").forEach(bindCatalogueFilter)
}

document.addEventListener("click", () => {
  document.querySelectorAll("[data-participants-catalogue-filter]").forEach((root) => {
    closeCatalogueMenu(root)
  })
})

document.addEventListener("turbolinks:before-cache", () => {
  document.querySelectorAll("[data-participants-catalogue-filter]").forEach((root) => {
    closeCatalogueMenu(root)
    root.dataset.bound = "false"
  })
})

export { initBackofficeParticipantsCatalogueFilter }
